import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { Project } from '@app/models/project';
import { Observable } from 'rxjs';
import { ProjectService } from '@app/services/project.service';
import { Environment } from '@environments/interface.environment';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-edit-project-retention-form',
  templateUrl: './edit-project-retention-form.component.html',
  styleUrls: ['./edit-project-retention-form.component.scss']
})
export class EditProjectRetentionFormComponent implements OnInit {

  pdpProjectId = this.route.snapshot.params['pdpProjectId'];
  project$: Observable<Project>;
  project: Project;
  errorMessage: string;
  viewState = 'form';

  selectedRetention: number;
  formGroupRetention: FormGroup;

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment,
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {

    this.formGroupRetention = this._formBuilder.group({
      Retention: new FormControl({})
    });

    this.project$ = this.projectService.getProject(this.pdpProjectId);
    this.project$.subscribe(p => {
      this.project = p;
      this.selectedRetention = p.Retention;
      this.changeDetectorRef.detectChanges();
      return p;
    });

  }

  updateProject() {
    this.viewState = 'working';

    this.project.Retention = this.selectedRetention;
    const req = this.projectService.updateProject(this.project);

    req.subscribe(result => {
      this.viewState = 'ready';
    },
      err => {
        console.log(err);
        this.errorMessage = err.message + ': ' + err.error;
        this.viewState = 'error';
        this.changeDetectorRef.detectChanges();
      });

  }

}
